import React from "react";
import lunch_image from "../../Assets/images/home/lunch_image.jpeg";
import program from "../../Assets/images/home/program.png";
import career_field from "../../Assets/images/home/career_field.png";
import expert_mentor from "../../Assets/images/home/expert_mentor.png";
import courses from "../../Assets/images/home/courses.png";

const Launch = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${lunch_image})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        // backgroundAttachment:'fixed'
      }}
      className=""
    >
      <div className="w-full h-full bg-[#141313cd] lg:px-20 px-5 py-10 over">
        <h1 className="lg:text-5xl md:text-3xl text-2xl text-white text-center font-bold tracking-wider leading-[1.2]">
          Mentoring <span className="text-primaryOrangeColor">Minds</span>,{" "}
          <br />
          Elevating <span className="text-primaryOrangeColor">Skills</span>,
          Accelerating <span className="text-primaryOrangeColor">Careers</span>
        </h1>
        <p className="text-white text-center md:text-2xl text-xl w-[90%] m-auto mt-8 tracking-wide">
          Our dedicated programs bridge the gap between potential and
          achievement. Join us to transform your passion into a thriving tech
          career.
        </p>

        <div className="grid md:grid-cols-4 grid-cols-2 md:gap-0 gap-8 justify-center  mt-8">
          <div className="text-white flex items-center justify-center ">
            <div className="flex flex-col gap-3">
              <img src={program} alt="5+ Programs" className="m-auto w-14" />
              <p className="2xl font-bold text-center">5+ Programs</p>
            </div>
          </div>
          <div className="text-white flex items-center justify-center ">
            <div className="flex flex-col gap-3">
              <img
                src={career_field}
                alt="5+ Programs"
                className="m-auto w-14"
              />
              <p className="2xl font-bold text-center">20+ Career Fields</p>
            </div>
          </div>
          <div className="text-white flex items-center justify-center ">
            <div className="flex flex-col gap-3">
              <img
                src={expert_mentor}
                alt="05+  PROGRAMS"
                className="m-auto w-14"
              />
              <p className="2xl font-bold text-center">50+ Expert Mentors</p>
            </div>
          </div>
          <div className="text-white flex items-center justify-center ">
            <div className="flex flex-col gap-3">
              <img src={program} alt="5+ Programs" className="m-auto w-14" />
              <p className="2xl font-bold text-center">30+ Courses</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white h-20">
        <div
          class="w-0 h-0 
   border-l-[40px] border-l-transparent
   border-t-[40px] border-[#141414]
   border-r-[40px] border-r-transparent m-auto"
        ></div>
      </div>
    </div>
  );
};

export default Launch;
